export const isRichEditorEmpty = (body) => {
    const regex = /(<([^>]+)>)/ig;
    return body.replace(regex, "").length === 0;
}